import React from 'react';
import NO_AVA_BIG from 'styles/img/no-ava-big.png';

export default class SoldItem extends React.Component {


  componentDidMount = () => {

  };

  render(){
    return(
      <div className="col-12">
        <div className="card regular purchases">
          <div className="purchases-content">
            <div className="card-top-wrap">
              <div className="card-head-avatar-holder">
                <div className="card-head-avatar">
                  {this.props.data.purchased_by.avatar_url ?
                    <img src={this.props.data.purchased_by.avatar_url} alt="avatar"/> :
                    <img src={NO_AVA_BIG} alt="avatar"/>
                  }
                </div>
                <div className="card-head-name-holder">
                  <span className="card-head-title">TRAINEE</span>
                  <span className="card-head-name">{this.props.data.purchased_by.full_name}</span>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="card-footer-top">
                <p className="card-title">{this.props.data.workshop_title}</p>
              </div>
              <div className="card-footer-bottom"/>
            </div>

          </div>
          <div className="purchases-price">
            <p className="caption">sold:</p>
            <p className="date">{this.props.data.purchased_at}</p>
            <p className="price">
              <span className="currency euro"/>{this.props.data.cost}
            </p>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sold/SoldItem.jsx